import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createBlock as _createBlock } from "vue"
import _imports_0 from '../../../static/img/illustrations/Folder.svg'


const _hoisted_1 = { class: "q-pa-md" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = {
  key: 0,
  class: "q-mb-md",
  src: _imports_0
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = {
  key: 0,
  class: "q-mt-md q-mb-md"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_inner_loading = _resolveComponent("q-inner-loading")!
  const _component_file_uploader = _resolveComponent("file-uploader")!
  const _component_q_step = _resolveComponent("q-step")!
  const _component_iap_chip = _resolveComponent("iap-chip")!
  const _component_file_report = _resolveComponent("file-report")!
  const _component_q_stepper = _resolveComponent("q-stepper")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_dialog_skeleton = _resolveComponent("dialog-skeleton")!

  return (_openBlock(), _createBlock(_component_dialog_skeleton, {
    title: _ctx.t('IMPORT_TITLE', { objects: _ctx.t(`${_ctx.objectKey}.LOW.PLUR`) }),
    "title-props": _ctx.TEXT_TERTIARY_TITLE,
    "confirm-label": _ctx.confirmLabel,
    "disable-confirm": _ctx.step === 1 ? _ctx.steps[1].error : !_ctx.steps[0].files?.length || !_ctx.steps[1].analyzed,
    loading: _ctx.step === 1 && _ctx.steps[1]?.loading,
    "cancel-label": _ctx.steps[0].done ? _ctx.t('IMPORT_BACK_BTN') : _ctx.t('IMPORT_CANCEL_BTN'),
    "disable-cancel": _ctx.steps[1].done,
    onConfirm: _ctx.confirm,
    onCancel: _ctx.cancel,
    "secondary-label": _ctx.step === 0 ? _ctx.t('STEP_1.BTN_INSTRUCTIONS') : null,
    onSecondary: _ctx.openInstructions,
    ref: "dialog"
  }, {
    content: _withCtx(() => [
      _createVNode(_component_q_card, {
        flat: "",
        id: "iap-import-stepper",
        ref: "iapImportStepper"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "q-pa-none" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_stepper, {
                animated: "",
                flat: "",
                "header-class": "hidden",
                ref: "stepper",
                modelValue: _ctx.step,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.step) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_step, {
                    done: _ctx.steps[0].done,
                    error: _ctx.steps[0].error,
                    name: 0,
                    title: _ctx.tinyScreen ? _ctx.t('STEP_2.TITLE_UPLOAD') : '',
                    class: "q-px-lg",
                    prefix: "1"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(_component_q_inner_loading, {
                          showing: _ctx.steps[1].loading
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_spinner, {
                              color: "primary",
                              size: "5em"
                            }),
                            _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.t('STEP_2.LOADING_FILES_MSG')), 1)
                          ]),
                          _: 1
                        }, 8, ["showing"]),
                        (!_ctx.steps[1].loading)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                              _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                  _createElementVNode("div", _mergeProps({ class: "q-pt-lg text-title-file" }, _ctx.TEXT_QUATERNARY_TITLE), _toDisplayString(_ctx.t('STEP_2.TITLE_UPLOAD')), 17),
                                  _createVNode(_component_file_uploader, {
                                    "browse-btn": "",
                                    class: "q-my-md import-file-uploader",
                                    accept: _ctx.steps[0].formats.join(', '),
                                    label: _ctx.t('STEP_2.UPLOADER.LABEL_MSG'),
                                    onBrowse: _cache[0] || (_cache[0] = ($event: any) => (_ctx.track(_ctx.ANALYTICS_EVENTS.IMPORT_DIALOG.BROWSE))),
                                    onDrop: _cache[1] || (_cache[1] = ($event: any) => (_ctx.track(_ctx.ANALYTICS_EVENTS.IMPORT_DIALOG.DRAG_DROP))),
                                    onUpload: _ctx.handleUpload,
                                    ref: "uploader"
                                  }, {
                                    image: _withCtx(() => [
                                      (!_ctx.steps[0].files.length)
                                        ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }, 8, ["accept", "label", "onUpload"])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }, 8, ["done", "error", "title"]),
                  _createVNode(_component_q_step, {
                    done: _ctx.steps[1].done,
                    error: _ctx.steps[1].error,
                    name: 1,
                    class: "q-px-lg q-py-md",
                    title: _ctx.tinyScreen ? _ctx.t('STEP_3.TITLE_FILE_ANALYSIS') : '',
                    prefix: "2"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _mergeProps(_ctx.TEXT_QUATERNARY_TITLE, { class: "text-title-file" }), _toDisplayString(_ctx.steps[1].done ? _ctx.t('STEP_3.TITLE_IMPORTED') : _ctx.t('STEP_3.TITLE_FILE_ANALYSIS')), 17),
                          (_ctx.steps[0].done && !_ctx.steps[1].done)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createElementVNode("div", _normalizeProps(_guardReactiveProps(_ctx.TEXT_CONTENT_BODY)), _toDisplayString(_ctx.t('STEP_3.IMPORTED_FILE')), 17),
                                _createVNode(_component_iap_chip, {
                                  class: "imported-file-chip",
                                  "non-interactive": "",
                                  tooltip: "",
                                  icon: _ctx.ICONS_NAME.FILE_OUTLINE,
                                  label: _ctx.steps[0].files[0]
                                }, null, 8, ["icon", "label"])
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_file_report, {
                            onNotImportable: _ctx.updateConfirmState,
                            "file-uploaded": _ctx.steps[0].files[0],
                            "errors-contains-warning": _ctx.errorsContainsWarning,
                            files: _ctx.steps[0].files[0],
                            "list-to-import": _ctx.listToImport || [],
                            "object-key": _ctx.objectKey,
                            "previous-step-loading": _ctx.steps[0].loading,
                            summary: _ctx.errorsListInParsing || [],
                            "result-data": _ctx.importResultStatus.data,
                            done: _ctx.steps[1].done
                          }, null, 8, ["onNotImportable", "file-uploaded", "errors-contains-warning", "files", "list-to-import", "object-key", "previous-step-loading", "summary", "result-data", "done"])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["done", "error", "title"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }, 8, ["title", "title-props", "confirm-label", "disable-confirm", "loading", "cancel-label", "disable-cancel", "onConfirm", "onCancel", "secondary-label", "onSecondary"]))
}